module.exports = __webpack_public_path__ + "static/img/electric-quantity.af39b08e.png";